import { delay } from "@/game/engine/delay";
import store from "@/store";

const SCROLLLER_ID = "https://lllcams.com/?AFNO=1-34315";

const SCROLLLER_AD_GIRL =
  "https://as.sexad.net/vast/live?tmpl=exampleTemplate&afno=1-46328&target=https://lllcams.com/landing/click/&hn=lllcams.com";
const SCROLLLER_AD_BOY =
  "https://as.sexad.net/vast/live?tmpl=exampleTemplate&afno=1-46328&target=https://lllcams.com/landing/click/&hn=lllcams.com";

export function openScrolllerAd() {
  const handle = window.open(SCROLLLER_ID, "_blank");

  if (handle) {
    window.posthog?.capture("successfully opened scrolller ad");
  } else {
    window.posthog?.capture("failed to open scrolller ad");
  }
}

export const showScrolllerAd = async (showWarmup?: boolean) => {
  const shoudlShowGayAd = Boolean(
    store.config.subreddits
      .map((subreddit) => subreddit.toLowerCase())
      .find((r) => r.includes("gay") || r.includes("fag"))
  );

  window.posthog?.capture("showing scrolller ad");

  store.game.ad = shoudlShowGayAd ? SCROLLLER_AD_BOY : SCROLLLER_AD_GIRL;

  try {
    await delay(20_000);
  } finally {
    // Interrupting the action rejects the delay, so the ad has to be torn down
    // here.  Otherwise it covers the media for the rest of the game.
    window.posthog?.capture("done showing scrolller ad");
    store.game.ad = null;
  }
};
showScrolllerAd.label = "Ad";

export const showScrolllerWarmupAd = async () => {
  return showScrolllerAd(true);
};
